import request from '../request'
export function getNewClass(){
  return request({
    url: '/rest/wNtNewsClass/queryNewClass',
    method: 'get'
  })
}
export function queryNewClassById(classId){
  return request({
    url: '/rest/wNtNewsClass/queryNewClassById/'+classId,
    method: 'get'
  })
}
export function queryParent(classId){
  return request({
    url: '/rest/wNtNewsClass/queryParent',
    method: 'get',
    params: {
      classId: classId
    }
  })
}
export function queryNewsClassByNewsId(newsId){
  return request({
    url: '/rest/wNtNewsClass/queryNewsClassByNewsId',
    method: 'get',
    params: {
      newsId: newsId
    }
  })
}
export function daoHang(classId){
  return request({
    url: '/rest/wNtNewsClass/daoHang',
    method: 'get',
    params: {
      classId: classId
    }
  })
}

export default { getNewClass,queryNewClassById,queryParent,queryNewsClassByNewsId,daoHang }


// WEBPACK FOOTER //
// ./src/http/web/newsClass.js